module.exports = __webpack_public_path__ + "assets/4_roboter_forskere-bd74b9bc97bcab915d48af86b2a87e3f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/4_roboter_forskere.jpg
// module id = 503
// module chunks = 1